import { ACTION, CATEGORY, EVENT } from './google-analytics.constants'

export type GADataLayerType = {
  event: EVENT
  event_category: CATEGORY | string
  event_action: ACTION | string
  event_label: string
}

export class DataLayer {
  event: EVENT
  category: CATEGORY | string
  action: ACTION | string
  label: string

  constructor(event: EVENT, category: CATEGORY | string, action: ACTION | string, label: string) {
    this.event = event
    this.category = category
    this.action = action
    this.label = label
  }

  toGADataLayerType(): GADataLayerType {
    return {
      event: this.event,
      event_category: this.category,
      event_action: this.action,
      event_label: this.label
    }
  }
}
